import React from "react";
import ReactECharts from "echarts-for-react";
import { Box, Typography, Card, CardContent } from "@material-ui/core";
import * as V from 'styles/variables';

const TsuruKubunPie = ({
  title,
  subtext,
  data,
}) => {
  const option = {
    title: {
      text: title,
      subtext: subtext,
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c} 件 ({d}%)",
    },
    color: V.genericColorPallette,
    legend: {
      orient: "vertical",
      left: "left",
      textStyle: {
        fontSize: 12,
      },
      bottom: 80,
    },
    series: [
      {
        name: "分類",
        type: "pie",
        radius: "60%",
        center: ["50%", "60%"],
        data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          position: 'outside',
          formatter: '{b}',
          fontSize: 12,
        },
      },
    ],
  };

  return (
    <Box style={{ width: "100%", height: 300 }}>
      <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
    </Box>
  );
};

export default TsuruKubunPie;
